module.exports = {
  "account_page": null,
  "shopping_cart_page": [
    {
      "language": "en-US",
      "slug": "/shopping-cart",
      "robots": "index,follow"
    }
  ],
  "not_found_page": [
    {
      "language": "en-US",
      "slug": "/page-not-found",
      "robots": "index,follow"
    },
    {
      "language": "nb-NO",
      "slug": "/nb-NO/side-ikke-funnet",
      "robots": "index,follow"
    }
  ]
}